<template>
  <div class="page_bg">
    <div class="bg_top_linear-gradient vip_linear-gradient">
      <!-- 顶部返回 -->
      <div class="back_top_name flex-r-sb-c">
        <van-icon name="arrow-left" @click="backPath" />
        <div class="top_name">权益中心</div>
        <div />
        <!-- <div class="top_icon" style="font-size: 0.32rem;" @click="(e) => { $router.push('/user/vipAuth') }"> 规则说明 </div> -->
      </div>
      <!-- vip 卡片切换 -->
      <swiper v-if="reloadSwiper" ref="carouselSwiper" class="service-advantage" :slides-per-view="1"
              :options="swiperOptions" @slideChange="slideChange"
      >
        <swiper-slide v-for="(item,index) in serviceAdvantageData" :key="`item${index}`"
                      :class="isVip ? 'slide bg'+ (index*1+1) :'slide sbg'+ (index*1+1) "
        >
          <div v-if="item.currentLevel === 1"
               :class="isVip ? 'vip_left left_bg'+ (index*1+1):'vip_left left_sbg'+ (index*1+1) "
          > 当前等级 </div>
          <div v-if="item.status === 2"
               :class="isVip ? 'vip_left left_bg'+ (index*1+1):'vip_left left_sbg'+ (index*1+1) "
          > 待解锁 </div>
          <div class="vip_level">
            <!-- vip -->
            <van-image v-if="isVip" width="3.52rem" height="0.64rem"
                       :src="`https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/VIP/vip_card_logo0${index*1+1}.png`"
            />
          </div>
          <div
            :class=" isVip ? 'vip_info flex-r-sa-c text_color'+(index*1+1):'vip_info flex-r-sa-c stext_color'+(index*1+1)"
          >
            <div class="vip_info_msg">
              <div class="info_title">本月全部商品</div>
              <div class="info_title">已消费{{ item.monthConsume }}元</div>
              <div v-if="item.status === 2 && item.wholesaleVipLevelId !== 1 && item.wholesaleVipLevelId !== 101"
                   class="info_tips"
              >还需消费{{ item.needMoney1 }}元</div>
              <div v-if="item.status === 2 && item.wholesaleVipLevelId !== 1 && item.wholesaleVipLevelId !== 101"
                   class="info_tips"
              >次月升级{{ item.nextLevel }}享{{ item.nextLevelCount }}折</div>
            </div>
            <div class="vip_info_huo flex-c-c-c">
              <span>|</span><span>或</span><span>|</span>
            </div>
            <div class="vip_info_msg">
              <div class="info_title">严选商品</div>
              <div class="info_title">已消费{{ item.monthPetfectConsume }}元</div>
              <div v-if="item.status === 2 && item.wholesaleVipLevelId !== 1 && item.wholesaleVipLevelId !== 101"
                   class="info_tips"
              >还需消费{{ item.needMoney2 }}元</div>
              <div v-if="item.status === 2 && item.wholesaleVipLevelId !== 1 && item.wholesaleVipLevelId !== 101"
                   class="info_tips"
              >次月升级{{ item.nextLevel }}享{{ item.nextLevelCount }}折</div>
            </div>
          </div>
          <div v-if="item.status === 3" :class=" isVip ? ' text_color'+(index*1+1):' stext_color'+(index*1+1)">
            <div class="svip_info_over">{{ item.expirationTime }}到期</div>
            <div class="svip_info_money">累计已省{{ item.accumulatedSaved }}元</div>
          </div>
          <div v-if="item.status === 1">
            <div :class=" isVip ? 'vip_info_over text_color'+(index*1+1):'vip_info_over stext_color'+(index*1+1)">
              您已超越该等级</div>
          </div>
        </swiper-slide>
      </swiper>
      <!-- tips -->
      <div class="vip_swiper_tip">
        <span>消费达到门槛,次月即可升级。左右滑动卡片,查看VIP规则</span>
      </div>
      <!-- 对应权益 -->
      <div class="vip_auth">
        <van-row type="flex" justify="space-around">
          <van-col v-for="(auth,auth_index) in vipAuthList" :key="auth_index" span="8" class="flex-c-c-c"
                   style="margin-top: 0.43rem;"
          >
            <van-image width="0.96rem" height="0.96rem"
                       :src="`https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/vip/del/vip_icon_0${auth.icon}.png`"
            />
            <div v-if="auth_index === 2" class="vip_auth_title">
              {{ auth.title }}{{ nowDiscount/10 + '折' }}
            </div>
            <div v-else class="vip_auth_title">{{ auth.title }}</div>
            <div v-if="myVipLevel === 1101 && swiperIndex === 0 && auth_index===0" class="vip_auth_msg">满999元包邮</div>
            <div v-else class="vip_auth_msg">{{ auth.msg }}</div>
          </van-col>
          <van-col v-for="(auth,auth_index) in 3 - vipAuthList.length" :key="auth_index" span="8" />
        </van-row>
      </div>
      <!-- 权益规则 -->
      <div class="vip_rules">
        <div class="rules_title flex-r-s-c">
          <van-image width="0.89rem" height="0.79rem" style="margin-top: 0.1rem;"
                     src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/VIP/auth_icon.png"
          />
          <span>规则说明</span>
        </div>
        <van-image width="9.6rem" height="11.63rem"
                   src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/VIP/auth_rule01.png"
        />
        <van-image width="9.6rem" height="6.4rem"
                   src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/VIP/auth_rule02.png"
        />
        <van-image width="9.6rem" height="6.4rem"
                   src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/VIP/auth_rule03-1.png"
        />
      </div>
    </div>
    <!-- 滑动提示 -->
    <van-dialog v-model="scrollDialog" :show-confirm-button="false" style="background: none;">
      <div class="scrollDialog_box flex-c-c-c">
        <van-image width="4.59rem" height="1.87rem"
                   src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/vip/scrollDialog.png"
        />
        <div class="scrollDialog_tips">左右滑动卡片，查看不同VIP规则</div>
        <div class="scrollDialog_btn" @click="scrollDialog = false">知道了</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import './vip.scss'
import { memberCenter, vipSlide } from '@/api/vip'
import { vipAuth1, vipAuth } from '@/utils/constants'
export default {
  name: 'VipDetail',
  data() {
    return {
      reloadSwiper: false,
      vipAuthList: vipAuth1,
      isVip: true,
      myVipLevel: null,
      serviceAdvantageData: [],
      nowVipLevel: {},
      swiperIndex: 0,
      nowDiscount: 100,
      swiperOptions: {
        initialSlide: 0,
        slidesPerView: 1.25, // 设置slider容器能够同时显示的slides数量,可以是小数,设置为2时,如图所示，设置为3则会出现三张完整的active slide，如API的例子,即设置为偶数时会自动使两边的缩进，类似遮盖一半的效果
        spaceBetween: -20,
        centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左
        loop: false,
        slideToClickedSlide: true, // true:点击slide会过渡到这个slide,默认false
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      scrollDialog: false
    }
  },
  created() {
    this.getVipInfo()
  },
  methods: {
    // 滑动提醒
    scrollTip() { vipSlide().then(res => { this.scrollDialog = res.data }) },
    backPath() { window.history.back() },
    slideChange(e) {
      this.vipAuthList = []
      this.swiperIndex = this.$refs.carouselSwiper.$swiper.activeIndex
      this.nowDiscount = this.serviceAdvantageData[this.swiperIndex].discount
      if (this.swiperIndex === 0) { this.vipAuthList = vipAuth1 } else { this.vipAuthList = vipAuth }
      console.log('下标1', this.swiperIndex, this.nowDiscount)
      console.log('下标2', this.vipAuthList)
    },
    // 获取vip信息
    getVipInfo() {
      memberCenter().then(res => {
        for (var j = 0; j < res.data.length; j++) {
          if (res.data[j].currentLevel === 1) {
            console.log('j', j)
            this.swiperOptions.initialSlide = j > 3 ? j - 4 : j
            console.log('this.swiperOptions.initialSlide', this.swiperOptions.initialSlide)
            this.swiperIndex = j
            this.myVipLevel = res.data[j].wholesaleVipLevelId
            this.nowDiscount = res.data[j].discount
            this.$set(res.data[j], 'status', 3)
            // 计算当前等级 的下一个等级的需求
            if (res.data[(j + 1)]) {
              this.$set(res.data[j], 'needMoney1',
                (res.data[(j + 1)].start - res.data[j].monthConsume) * 1 <= 0 ? 0 : (res.data[(j + 1)].start - res.data[j].monthConsume).toFixed(2))
              this.$set(res.data[j], 'needMoney2',
                (res.data[(j + 1)].petfectStart - res.data[j].monthPetfectConsume) * 1 <= 0 ? 0 : (res.data[(j + 1)].petfectStart - res.data[j].monthPetfectConsume).toFixed(2))
              this.$set(res.data[j], 'nextLevel', res.data[(j + 1)].wholesaleVipLevelName)
              this.$set(res.data[j], 'nextLevelCount', res.data[(j + 1)].discount)
            }
          }
        }
        this.$nextTick(() => {
          var start = 0
          var lengthMax = 4
          for (var i = start; i < lengthMax; i++) {
            // status  1:已超过 2:未达到 3:当前
            if (res.data[i].wholesaleVipLevelId < this.myVipLevel) { this.$set(res.data[i], 'status', 1) }
            if (res.data[i].wholesaleVipLevelId > this.myVipLevel) { this.$set(res.data[i], 'status', 2) }
            if (res.data[i].currentLevel === 2) {
              this.$set(res.data[i], 'needMoney1',
                (res.data[i].start - res.data[i].monthConsume) * 1 <= 0 ? 0 : (res.data[i].start - res.data[i].monthConsume).toFixed(2))
              this.$set(res.data[i], 'needMoney2',
                (res.data[i].petfectStart - res.data[i].monthPetfectConsume) * 1 <= 0 ? 0 : (res.data[i].petfectStart - res.data[i].monthPetfectConsume).toFixed(2))
              this.$set(res.data[i], 'nextLevel', res.data[i].wholesaleVipLevelName)
              this.$set(res.data[i], 'nextLevelCount', res.data[i].discount)
            }
            this.isVip = i < 4
            this.vipAuthList = vipAuth
            if (parseInt(this.myVipLevel) === 1101) { this.vipAuthList = vipAuth1 }
            this.serviceAdvantageData.push(res.data[i])
          }
          this.reloadSwiper = true
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-slide {
  // width: 8.85rem !important;
  height: 5.62rem !important;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}

.slide {
  position: relative;
  width: 100%;

  &:nth-child(2n) {
    width: 60%;
  }
  &:nth-child(3n) {
    width: 40%;
  }
}
.scrollDialog_tips {
  font-size: 0.37rem;
  color: #fff;
  margin-top: 0.2rem;
}
.scrollDialog_btn {
  width: 4.11rem;
  height: 1.07rem;
  line-height: 1.07rem;
  text-align: center;
  border-radius: 0.53rem;
  background: #fff;
  border: 0.03rem solid #f5f5f5;

  font-size: 0.48rem;
  color: #0d0e15;

  margin-top: 1rem;
}
</style>
